import { icons } from "constants/icons";
import { memo } from "react";

import { ScoreConfig } from "types/PatientRegion";
import { RegionInfoItems } from "./RegionInfoItems";

type Props = {
  title: string;
  subtitle?: string;
  lastExam: string;
  score?: ScoreConfig;
  videoExamsQuantity: number;
  week: number;
};
export const RegionBlock = memo(
  ({
    title,
    subtitle = "",
    lastExam,
    score,
    videoExamsQuantity,
    week,
  }: Props) => {
    return (
      <>
        <div className="flex justify-between">
          <div className="flex space-x-2 items-center">
            <img src={icons.status} alt="status" />
            <div className="flex flex-col">
              <h4 className="text-grayDark leading-4">Exam types</h4>
              <p className="flex items-baseline space-x-1  text-grayDark">
                <strong className="text-[24px] text-black leading-6 w-max">
                Double Knee Drop Jump
                </strong>
              </p>

            </div>
          </div>

          <RegionInfoItems
            classNames="w-[263px]"
            title="Last Exam"
            lastExamDate={lastExam[lastExam.length - 1]}
            // score={score}
            videoExamsQuantity={videoExamsQuantity}
            // weekNumber={week}
          />
        

        </div>
        {/* <div>Graph</div> */}
      </>
    );
  }
);
